import { z } from 'zod'

import { Permission } from './permission'

import { Pagination } from 'app/types/app/request'
import { Manager, ManagerBinding } from 'app/types/park/manager'

/** Profile containing a group of multiple permissions. */
export const Profile = z.object({
    id: z.number().positive(),
    name: z.string().min(1),
    description: z.string().min(1),
    client: ManagerBinding.nullable(),
    permissions: Permission.array(),
})

export type Profile = z.infer<typeof Profile>

/** Profile list request. */
export const ProfilesRequest = Pagination.extend({
    results: Profile.array(),
})

export type ProfilesRequest = z.infer<typeof ProfilesRequest>

export const ProfilePayload = Profile.omit({
    id: true,
}).extend({
    client: Manager.shape.id.nullable(),
    permissions: Permission.shape.id.array(),
})

export type ProfilePayload = z.infer<typeof ProfilePayload>

export const ProfileForm = ProfilePayload.extend({
    permissions: Permission.shape.codename.array(),
})

export type ProfileForm = z.infer<typeof ProfileForm>
